export default __webpack_public_path__ + "static/media/thetimesLogo.906cdef0.png";